module.exports = __webpack_public_path__ + "img/logo_mohpromt2.e6d80023.png";